<template>
  <Modal
    v-model="_value"
    width="500"
    title="添加定位设备配件类型"
    @on-visible-change="visibleChange"
    ok-text="添加"
    @on-ok="onOk">
    <Form ref="loginForm" :model="positioningDeviceFittingsType" :rules="rules">
      <FormItem prop="name">
        <label>定位设备配件型号：</label>
        <Input v-model="positioningDeviceFittingsType.name" placeholder="请输入定位设备配件型号">
        </Input>
      </FormItem>
      <FormItem prop="manufacturer">
        <label>定位设备配件类型：</label>
<!--        <Input v-model="positioningDeviceFittingsType.type" placeholder="请输入配件类型">-->
<!--        </Input>-->
        <Select placeholder="请选择配件类型" style="display: inline-block; width: 200px;"
                v-model="positioningDeviceFittingsType.type"
        >
          <Option v-for="(option, index) in FittingsType" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="manufacturername">
        <label>定位设备配件生产商型号：</label>
        <Input v-model="positioningDeviceFittingsType.manufacturername" placeholder="请输入定位设备配件型号">
        </Input>
      </FormItem>
      <FormItem prop="manufacturer">
        <label>设备配件生产商：</label>
        <Input v-model="positioningDeviceFittingsType.manufacturer" placeholder="请输入配件生产商">
        </Input>
      </FormItem>
      <FormItem prop="parameter">
        <label>设备配件参数：</label>
        <Input v-model="positioningDeviceFittingsType.parameter" placeholder="请输入设备配件参数">
        </Input>
      </FormItem>
      <FormItem prop="remark">
        <label>设备配件备注：</label>
        <Input type="textarea" v-model="positioningDeviceFittingsType.remark" placeholder="请输入配件备注">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'addpositioningdevicefittingstypemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    name: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '定位设备配件型号不能为空', trigger: 'blur' }
        ]
      }
    },
    manufacturername: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '定位设备配件生厂商型号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      // positioningDeviceInfoStateOptions: [
      //   { label: '未安装', value: 1 },
      //   { label: '已安装', value: 2 },
      //   { label: '损坏', value: 3 }
      // ],
      // positioningDeviceModelOptions: [
      //   { label: 'BSJ-A6-BD', value: 1 },
      //   { label: 'BSJ-GF03', value: 2 },
      //   { label: 'BSJ-M11', value: 3 },
      //   { label: 'BSJ-A6L', value: 13 },
      //   { label: 'BSJ-A7', value: 14 },
      //   { label: 'K5', value: 4 },
      //   { label: 'D5X', value: 5 },
      //   { label: 'G-3G', value: 6 },
      //   { label: 'D5X-HDD', value: 7 },
      //   { label: 'D5X-XR', value: 8 },
      //   { label: 'BSJ-GF06', value: 9 },
      //   { label: 'BSJ-RM01', value: 10 },
      //   { label: 'HIK-A3', value: 11 },
      //   { label: 'HIK-A3L', value: 12 }
      // ],
      // positioningDeviceSourceTypeOptions: [
      //   { label: '新装', value: 1 },
      //   { label: '接入', value: 2 }
      // ],
      FittingsType: [
        { label: '摄像头', value: 1 },
        { label: '显示屏', value: 2 },
        { label: '延长线', value: 3 },
        { label: '硬盘', value: 4 },
        { label: '声光报警', value: 5 },
        { label: '对讲机', value: 6 },
        { label: '喇叭', value: 7 },
        { label: '天线', value: 8 },
        { label: '电源线', value: 9 }
      ],

      positioningDeviceFittingsType: {
        name: null,
        type: null,
        manufacturername: null,
        manufacturer: null,
        parameter: null,
        remark: null
      }
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceFittingsTypeServ_AddObj'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '添加定位设备配件类型',
        content: '<p>是否确认添加定位设备配件类型</p>',
        onOk: () => {
          store.dispatch('PositioningDeviceFittingsTypeServ_AddObj', { params: this.positioningDeviceFittingsType }).then(() => {
            this.$Message.success('添加定位设备配件类型成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.positioningDeviceFittingsType.name = null
        this.positioningDeviceFittingsType.type = null
        this.positioningDeviceFittingsType.parameter = null
        this.positioningDeviceFittingsType.manufacturername = null
        this.positioningDeviceFittingsType.manufacturer = null
        this.positioningDeviceFittingsType.remark = null
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        name: this.name,
        manufacturername: this.manufacturername
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
